import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { assetUrl } from "../utils/api";

export default function Profile() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    avatar: "",
    name: "",
    age: "",
    city: "",
    job: "",
    bio: "",
  });

  // ✅ 读取本地数据
  useEffect(() => {
    const saved = localStorage.getItem("profile");
    if (saved) {
      setForm(JSON.parse(saved));
    }
  }, []);

  // 输入变化
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // 上传头像（转 base64 存储）
  const handleUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setForm({
        ...form,
        avatar: reader.result,
      });
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  // 保存
  const handleSave = () => {
    localStorage.setItem("profile", JSON.stringify(form));
    alert("保存成功！");
    navigate("/match");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-purple-50 p-6">

      <h2 className="text-2xl font-bold text-center mb-6">
        完善个人资料
      </h2>

      <div className="max-w-xl mx-auto bg-white p-6 rounded-2xl shadow space-y-4">

        {/* 头像 */}
        <div className="text-center">
          <label className="cursor-pointer">
            <input type="file" onChange={handleUpload} className="hidden" />
            <img
              src={form.avatar ? assetUrl(form.avatar) : "https://via.placeholder.com/100"}
              alt=""
              className="w-24 h-24 rounded-full mx-auto object-cover border"
            />
            <p className="text-sm text-gray-500 mt-2">点击上传头像</p>
          </label>
        </div>

        {/* 表单 */}
        <input
          name="name"
          value={form.name}
          onChange={handleChange}
          placeholder="姓名"
          className="w-full border p-3 rounded-lg"
        />

        <input
          name="age"
          value={form.age}
          onChange={handleChange}
          placeholder="年龄"
          className="w-full border p-3 rounded-lg"
        />

        <input
          name="city"
          value={form.city}
          onChange={handleChange}
          placeholder="城市"
          className="w-full border p-3 rounded-lg"
        />

        <input
          name="job"
          value={form.job}
          onChange={handleChange}
          placeholder="职业"
          className="w-full border p-3 rounded-lg"
        />

        <textarea
          name="bio"
          value={form.bio}
          onChange={handleChange}
          placeholder="简单介绍一下自己..."
          className="w-full border p-3 rounded-lg"
        />

        {/* 保存按钮 */}
        <button
          onClick={handleSave}
          className="w-full bg-pink-500 text-white py-3 rounded-lg hover:bg-pink-600"
        >
          保存并进入匹配
        </button>

      </div>
    </div>
  );
}
